import React, { useState } from "react";
import { Button, Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import { MessageBoxComponent } from "../gui_components/UIComponents.js";
import {
  AddressBean,
  RestReadRequest,
  RestInvoicePrintoutTypeListRequest,
  InvoicePrintoutTypeBean,
  InvoicePrintoutTypeSearchCriteria,
  AttributeImageBean,
} from "../ds/ds.js";
import { DeleteIcon, CameraIcon } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  ColumnDefinition,
  InputCheckbox,
  InputTextbox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { ConfigManager } from "../config/ConfigManager.js";
import noImage from "../images/clicktoAdd.png";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
import CustomTable from "../gui_components/CustomTable.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { Attributetypes } from "../ds/AttributeTypes.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import { useEffect } from "react";
class InvoicePrintTypeListForm extends React.Component {
  constructor(props) {
    super(props);
    // this.listFormCodeRef = React.createRef();
  }
  componentDidMount() {}
  // componentDidUpdate() {
  //   this.setInputFocus();
  // }
  // setInputFocus() {
  //   if (this.listFormCodeRef.current != null) {
  //     this.listFormCodeRef.current.focus();
  //   }
  // }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  editInvoicePrintType = (e, val, rowData) => {
    if (e.detail === 1) this.props.editInvoicePrintType(val);
  };
  deleteInvoicePrintType = (e, val, rowData) => {
    if (e.detail === 1) this.props.deleteInvoicePrintType(val, rowData);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };

  getListColumns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("InvoicePrint", "code", true)

        .setStyleDetails("left", "", "", "wt-4", " wt-4")

        .setClickDetails(true, false, this.editInvoicePrintType, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "description", true)
        .setStyleDetails("left", "", "", "wt-8", "wt-8")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Company", "companyCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Active", "isActive", true)
        .setStyleDetails("center", "", "", "wt-3", "wt-3")
        .setInputDetails(false, false, true, null, null, null)
    );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("", <DeleteIcon />, true)

    //     .setStyleDetails("left", "", "", "wt-4", " wt-4")

    //     .setClickDetails(
    //       false,
    //       true,
    //       this.deleteInvoicePrintType,
    //       <DeleteIcon />
    //     )
    // );

    return columns;
  };

  render() {
    let invoicePrintList = this.props.invoicePrintList;
    return (
      <div>
        <div className="div_Custom_2">
          <CustomTable
            columns={this.getListColumns()}
            data={invoicePrintList}
            label={"Invoice Printout List"}
          />
        </div>
      </div>
    );
  }
}
class InvoicePrintTypeEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
  }
  componentDidMount() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  onAddressChange = (e) => {
    this.props.onAddressChange(e);
  };

  render() {
    let invoicePrintTypeData = this.props.invoicePrintTypeData;
    let isDisableFields = this.props.isDisableFields;
    let addressData = this.props.addressData;
    return (
      <div>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Company</FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <InputTextbox
              type="text"
              name="companyCode"
              onChange={this.onChange}
              value={invoicePrintTypeData.companyCode}
              disabled={true}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel> Code</FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <InputTextbox
              ref={this.codeRef}
              name="code"
              type="text"
              placeholder="Enter  Code"
              disabled={isDisableFields}
              onChange={this.onChange}
              value={invoicePrintTypeData.code}
              style={{ "text-transform": "uppercase" }}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Name</FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter  Name"
              onChange={this.onChange}
              value={invoicePrintTypeData.description}
              style={{ "text-transform": "uppercase" }}
              isMandatory={true}
            />{" "}
          </Col>
        </Row>
        <br />
        <Row>
          <Col sm="1">
            <FormLabel>isActive</FormLabel>
          </Col>
          <Col sm="1">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={invoicePrintTypeData.isActive}
            />
          </Col>
        </Row>
        <div>
          <Row>
            <Col sm="2">
              <FormLabel className="address">Address</FormLabel>
            </Col>
          </Row>
          <hr class="row_border"></hr>
          <Row>
            <Col sm="2">
              <FormLabel>Address1</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="address1"
                type="text"
                placeholder="Enter Address1"
                onChange={this.onAddressChange}
                value={addressData.address1}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Country</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                onChange={this.props.onCountryChange}
                name="country"
                placeholder="country"
                valuePropery="code"
                descriptionProperty="description"
                value={addressData.country}
                lookupRequired={true}
                lookupHandler={this.props.countryLookupHandler}
                enterKeyEventHandler={this.props.countryCodeEnterKeyEvent}
                autoCompleteListData={
                  this.props.countryCodePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.props.displayAutoCompleteCountryCodeList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteCountryCodeList
                }
              />
            </Col>
            <Col sm="2">
              <FormLabel>Phone#2</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="phone2"
                type="text"
                placeholder="Enter Phone2"
                onChange={this.onAddressChange}
                value={addressData.phone2}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <FormLabel>Address2</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="address2"
                type="text"
                placeholder="Enter Address2"
                onChange={this.onAddressChange}
                value={addressData.address2}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Zip</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="zip"
                type="text"
                placeholder="Enter Zip"
                onChange={this.onAddressChange}
                value={addressData.zip}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Mobile#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="mobilePhone"
                type="text"
                placeholder="Enter MobileNo"
                onChange={this.onAddressChange}
                value={addressData.mobilePhone}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <FormLabel>City</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.props.onCityChange}
                name="city"
                placeholder="city"
                value={addressData.city}
                lookupRequired={true}
                lookupHandler={this.props.cityLookupHandler}
                enterKeyEventHandler={this.props.cityEnterKeyEvent}
                autoCompleteListData={
                  this.props.cityPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.props.displayAutoCompleteCityList}
                showAutoCompleteList={this.props.showAutoCompleteCityList}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Contact Person</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="contactPerson"
                type="text"
                placeholder="ContactPerson"
                onChange={this.onAddressChange}
                value={addressData.contactPerson}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Email</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="email"
                type="text"
                placeholder="Enter Email"
                onChange={this.onAddressChange}
                value={addressData.email}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <FormLabel>State</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.props.onStateChange}
                name="state"
                placeholder="state"
                value={addressData.state}
                lookupRequired={true}
                lookupHandler={this.props.stateLookupHandler}
                enterKeyEventHandler={this.props.stateEnterKeyEvent}
                autoCompleteListData={
                  this.props.statePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.props.displayAutoCompleteStateList
                }
                showAutoCompleteList={this.props.showAutoCompleteStateList}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Phone#1</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="phone1"
                type="text"
                placeholder="Enter PhoneNo1"
                onChange={this.onAddressChange}
                value={addressData.phone1}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Website</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="website"
                type="text"
                placeholder="Enter Website"
                onChange={this.onAddressChange}
                value={addressData.website}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
          </Row>

          <br />
        </div>

        <Row>
          <Col sm="1">
            <FormLabel>Images</FormLabel>
          </Col>

          <Col sm="2">
            <PrintoutTypeLogo {...this.props} />
          </Col>
        </Row>
      </div>
    );
  }
}

class InvoicePrintTypeList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
    this.state = {
      invoicePrintList: [],
      pageTitle: "Invoice Printout Type",
      invoicePrintTypeData: new InvoicePrintoutTypeBean(),
      pageList: new PageListBean(),
      criteria: new InvoicePrintoutTypeSearchCriteria(),
      addressData: new AddressBean(),
      countries: [],
      cities: [],
      states: [],
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      currentPageNumber: 0,
      totalCount: 0,
      isListFormOpen: true,
      isEntryFormOpen: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowExitButton: true,
      loadingText: "",
      isLoading: false,
      progressLoadingText: "",
      isShowProgressBarPopup: false,
      isDisableFields: false,

      countryLookupHandler: null,
      showAutoCompleteCountryCodeList: true,
      countryCodePageListForAutoCompleteList: new Array(),
      cityLookupHandler: null,
      showAutoCompleteCityList: true,
      cityPageListForAutoCompleteList: new Array(),
      stateLookupHandler: null,
      showAutoCompleteStateList: true,
      statePageListForAutoCompleteList: new Array(),

      imageUrl: "",
      imageData: null,

      isShowWarningMsgPopup: false,
      warningMessage: "",
    };
    this.moduleCaption = "Invoice Printout Type";
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    let invoicePrintTypeData = new InvoicePrintoutTypeBean();
    invoicePrintTypeData.companyCode = this.companyCode;
    this.loadPage(1);
    this.setState({ invoicePrintTypeData: invoicePrintTypeData });
    this.loadFromCache();
    this.initLookupHandlers();
  }
  loadFromCache = () => {
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };

    const countries = new Array();
    if (!isEmptyArray(attribute_cache.countries))
      countries.push(...attribute_cache.countries);
    this.state.countries = countries;
    const states = new Array();
    if (!isEmptyArray(attribute_cache.states))
      states.push(...attribute_cache.states);
    this.state.states = states;
    const cities = new Array();
    if (!isEmptyArray(attribute_cache.cities))
      cities.push(...attribute_cache.cities);
    this.state.cities = cities;
  };
  initLookupHandlers = () => {
    let cityLookupHandler = new GenericAttributeLookupHandler(
      this.state.cities,
      "City"
    );
    this.setState({ cityLookupHandler: cityLookupHandler });
    let stateLookupHandler = new GenericAttributeLookupHandler(
      this.state.states,
      "State"
    );
    this.setState({ stateLookupHandler: stateLookupHandler });

    let countryLookupHandler = new GenericAttributeLookupHandler(
      this.state.countries,
      "Country"
    );
    this.setState({ countryLookupHandler: countryLookupHandler });
  };
  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }

  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  onChange = (e) => {
    let invoicePrintTypeData = this.state.invoicePrintTypeData;
    invoicePrintTypeData[e.target.name] = e.target.value;
    this.setState({ invoicePrintTypeData: invoicePrintTypeData });
  };

  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadInvoicePrintType(criteria, pageInput);
  };
  validateData = (data) => {
    let isValidateData = false;
    let err_list = [];
    let errorMessage = "";
    if (data == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(data.code)) {
        let errMsg = "Code is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.description)) {
        let errMsg = "Name is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidateData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValidateData = true;
      this.setState({ isShowAlert: false });
    }
    return isValidateData;
  };

  onYesButtonClick = (isSavedWithWarning) => {
    this.isSavedWithWarning(true);
  };
  onNoButtonClick = (isSavedWithWarning) => {
    this.isSavedWithWarning(false);
  };
  isSavedWithWarning = (isSavedWithWarning) => {
    if (isSavedWithWarning) {
      this.saveInvoicePrintType();
    }
    this.closeMessageModelCallBack();
  };
  closeMessageModelCallBack = () => {
    this.setState({ isShowWarningMsgPopup: false });
  };

  save = () => {
    const invoicePrintTypeData = this.state.invoicePrintTypeData;
    let warningMessage = "";
    if (isEmptyArray(invoicePrintTypeData.images)) {
      warningMessage =
        "[Warning] Invoice PrintOut Image Not Found." +
        "\n" +
        " Do you want to proceed with the Invoice PrintOut ?";
      this.setState({
        isShowWarningMsgPopup: true,
        warningMessage: warningMessage,
      });
    } else {
      this.saveInvoicePrintType();
    }
  };
  // save = () => {
  //   this.saveInvoicePrintType();
  // };
  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeEntryForm();
  };
  cleardata = () => {
    let invoicePrintTypeData = new InvoicePrintoutTypeBean();
    invoicePrintTypeData.companyCode = this.companyCode;
    let addressData = new AddressBean();
    addressData.companyCode = this.companyCode;
    this.setState({
      invoicePrintTypeData: invoicePrintTypeData,
      addressData: addressData,
      imageUrl: "",
      imageData: null,
    });
  };
  clickGoButton = () => {
    let invoicePrintTypeData = this.state.invoicePrintTypeData;
    this.editInvoicePrintType(invoicePrintTypeData.code);
  };
  openEntryForm = () => {
    this.setState({
      isListFormOpen: false,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
      isEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowAlert: false,
    });
  };
  closeEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isListFormOpen: true,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isDisableFields: false,

      countryLookupHandler: null,
      showAutoCompleteCountryCodeList: true,
      countryCodePageListForAutoCompleteList: new Array(),
      cityLookupHandler: null,
      showAutoCompleteCityList: true,
      cityPageListForAutoCompleteList: new Array(),
      stateLookupHandler: null,
      showAutoCompleteStateList: true,
      statePageListForAutoCompleteList: new Array(),
      imageUrl: "",
      imageData: null,
    });
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.clickGoButton();
    }, 200);
  };
  loadPageResponse = (response) => {
    if (
      response.data != null &&
      response.data.invoicePrintoutTypePageList != null &&
      response.data.invoicePrintoutTypePageList.invoicePrintoutTypes != null
    ) {
      let invoicePrintList =
        response.data.invoicePrintoutTypePageList.invoicePrintoutTypes;
      let pageList = this.state.pageList;
      pageList.currentPage =
        response.data.invoicePrintoutTypePageList.currentPage;
      pageList.pageSize = response.data.invoicePrintoutTypePageList.pageSize;
      pageList.totalCount =
        response.data.invoicePrintoutTypePageList.totalCount;
      this.setState({
        invoicePrintList: invoicePrintList,
        pageList: pageList,
      });
    }
  };
  loadInvoicePrintType = (criteria, pageList) => {
    let requestInput = new RestInvoicePrintoutTypeListRequest();
    requestInput.searchCriteria = criteria;
    requestInput.pageInput = pageList;
    // if (SecurityAccessManager.serviceDetailsView_isAccessible()) {
    MasterService.getInvoicePrintoutTypePageList(
      requestInput,
      this.loadPageResponse,
      this.errorCallBack
    );
    // } else {
    //   let errMsg = "Access Denied";
    //   let errList = [];
    //   errList.push(errMsg);
    //   this.setState({
    //     alertMessage: errList,
    //     alertType: "danger",
    //     isShowAlert: true,
    //   });
    // }
  };
  loadSaveResponse = (response) => {
    this.handleresponse(response.data);
    this.uploadImagesToServer();
    this.loadPage(1);
    this.cleardata();
    this.closeEntryForm();
  };
  saveInvoicePrintType = () => {
    let input = this.state.invoicePrintTypeData;
    input.address = this.state.addressData;

    if (input.isFetched == true) {
      if (SecurityAccessManager.TestTrue_IsAccessible()) {
        MasterService.updateInvoicePrintoutType(
          input,
          this.loadSaveResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (SecurityAccessManager.TestTrue_IsAccessible()) {
        MasterService.createInvoicePrintoutType(
          input,
          this.loadSaveResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadEditResponse = (response) => {
    if (response.data != null) {
      if (response.data.invoicePrintoutTypeBean != null) {
        const invoicePrintTypeData = response.data.invoicePrintoutTypeBean;
        if (invoicePrintTypeData.address != null) {
          this.setState({
            addressData: invoicePrintTypeData.address,
          });
        }

        if (!isEmptyArray(invoicePrintTypeData.images)) {
          const imagesList = invoicePrintTypeData.images;
          imagesList.map((imgData) => {
            if (imgData.imagePart == "Main") {
              let url = this.getImageURL();
              /* replaces spaces to modulus */
              const img_name = imgData.imageName.replace(/ /g, "%20");
              url = url + img_name;
              this.setUrl(url);
            }
          });
          this.setState({
            imageData: null,
          });
        } else {
          this.setState({
            imageUrl: "",

            imageData: null,
          });
        }

        this.setState({
          invoicePrintTypeData: invoicePrintTypeData,
        });
        this.disable();
      }
    }
    this.openEntryForm();
  };
  editInvoicePrintType = (code) => {
    let readRequest = new RestReadRequest();
    readRequest.companyCode = this.companyCode;
    readRequest.code = code;
    if (SecurityAccessManager.TestTrue_IsAccessible()) {
      MasterService.readInvoicePrintoutType(
        readRequest,
        this.loadEditResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  deleteInvoicePrintType = (code, rowData) => {
    let criteria = new InvoicePrintoutTypeSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.code = rowData.code;
    if (SecurityAccessManager.TestTrue_IsAccessible()) {
      MasterService.deleteInvoicePrintoutType(
        criteria,
        this.deleteInvoicePrintResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Delete Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  deleteInvoicePrintResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
  };

  /**************************Image *************************/

  getImageURL = () => {
    const { appData } = this.context;
    let serviceURL = appData.serviceURL;
    let imageURL = serviceURL + "/printoutType_logo?file=";
    return imageURL;
  };
  setUrl = (url) => {
    setTimeout(() => {
      this.setState({
        imageUrl: url,
      });
    }, 200);
  };
  showToast = (msg, type) => {
    let errList = [];
    if (type === 1) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (type === 2) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  toServer = (file, fileName) => {
    let image = new File([file], `${fileName}`, { type: file.type });
    const formData = new FormData();
    formData.append("file", image);
    MasterService.invoiceReportTypeLogoUpload(
      formData,
      this.uploadImageServerResponse,
      this.errorCallBack
    );
  };

  uploadImageServerResponse = (response) => {
    // if (response.data.success) {
    //   this.closeTestImagePopup(false);
    // }
    // this.showToast("")
  };

  uploadImagesToServer = () => {
    const entity__Data = { ...this.state.invoicePrintTypeData };
    const img = this.state.imageData;
    if (!isEmptyArray(entity__Data.images)) {
      entity__Data.images.map((imgData) => {
        if (imgData.imagePart == "Main" && imgData.isDeleted != true) {
          if (!isEmpty(img)) this.toServer(img, imgData.imageName);
        }
      });
    }
  };

  uploadImage = (file, imagePart) => {
    //

    /* push images to attribute images array  */

    const entity__Data = { ...this.state.invoicePrintTypeData };
    let image__Data = null;
    if (!isEmptyArray)
      entity__Data.images.map((img, i) => {
        if (img.imagePart == imagePart) image__Data = img;
        if (image__Data.isDeleted === true) image__Data.isDeleted = false;
      });

    if (!isEmpty(image__Data)) {
      image__Data.imageOritinalname = file.name;
      this.setState({
        invoicePrintTypeData: entity__Data,
      });
    } else {
      image__Data = new AttributeImageBean();
      image__Data.imagePart = imagePart;
      image__Data.imageOritinalname = file.name;
      const imageName =
        LogicConstants.INVOICE_PRINTOUT_LOGO_IMAGE_NAME_PREFIX +
        this.companyCode +
        "_" +
        Attributetypes.INVOICE_PRINT_TYPE_TYPE +
        "_" +
        entity__Data.code;

      image__Data.imageName = imageName;
      // image__Data.imageName = file.name;
      image__Data.companyCode = this.companyCode;
      image__Data.attributeType = Attributetypes.INVOICE_PRINT_TYPE_TYPE;
      image__Data.attributeCode = entity__Data.code;

      entity__Data.images.push(image__Data);
      this.setState({
        invoicePrintTypeData: entity__Data,
      });
    }
  };

  setImg = (data) => {
    this.setState({
      imageData: data,
    });
  };

  deleteImage = () => {
    //
  };

  /******************************* Address ************************/
  onAddressChange = (e) => {
    let temp_addressData = this.state.addressData;
    temp_addressData[e.target.name] = e.target.value;
    this.setState({ addressData: temp_addressData });
  };

  onCountryChange = (e) => {
    let country = e.target.value;
    this.state.showAutoCompleteCountryCodeList = true;
    let addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
    if (isEmpty(country)) {
      this.state.showAutoCompleteCountryCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
      let addressData = this.state.addressData;
      addressData.country = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCountryCodeList: showAutoCompleteList,
        addressData: addressData,
        countryCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && country !== "") {
      this.readcountryCodeBySearchString(country);
    }
    if (e.target.name == "country") {
      addressData["country"] = e.target.value;
      let country_List = this.state.countries;
      country_List.map((country) => {
        if (country.code == e.target.value) {
          addressData["country"] = country.code;

          this.state.showAutoCompleteCountryCodeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
          this.setState({
            showAutoCompleteCountryCodeList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ addressData: addressData });
  };
  readcountryCodeBySearchString(searchString) {
    let countryData = this.state.countries;
    let simpleAutoCompleteList = new Array();
    if (countryData.length > 0 && countryData != null) {
      countryData.map((countryDatas) => {
        let simpleItemBean = {
          code: countryDatas.code,
          description: countryDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecountryLists) =>
        simpleAutoCompletecountryLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      countryCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  countryCodeEnterKeyEvent = (e) => {
    let addressData = this.state.addressData;
    let country = e.target.value;

    addressData["country"] = e.target.value;
    let country_List = this.state.countries;
    let countryBean = null;
    country_List.map((country) => {
      if (country.code == e.target.value) {
        countryBean = country;
      }
    });
    if (!isEmpty(countryBean)) {
      let addressData = this.state.addressData;
      addressData.country = countryBean.code;

      this.setState({
        addressData: addressData,
        countryCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCountryCodeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCountryCodeList: showAutoCompleteList });
  };

  //city

  onCityChange = (e) => {
    let city = e.target.value;
    this.state.showAutoCompleteCityList = true;
    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;
    if (isEmpty(city)) {
      this.state.showAutoCompleteCityList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let temp_addressData = this.state.addressData;
      temp_addressData.city = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteCityList: showAutoCompleteList,
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && city !== "") {
      this.readcityBySearchString(city);
    }
    if (e.target.name == "city") {
      temp_addressData["city"] = e.target.value;
      let city_List = this.state.cities;
      city_List.map((city) => {
        if (city.code == e.target.value) {
          temp_addressData["city"] = city.code;

          this.state.showAutoCompleteCityList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCityList;
          this.setState({ showAutoCompleteCityList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: temp_addressData });
  };
  readcityBySearchString(searchString) {
    let cityData = this.state.cities;
    let simpleAutoCompleteList = new Array();
    if (cityData.length > 0 && cityData != null) {
      cityData.map((cityDatas) => {
        let simpleItemBean = {
          code: cityDatas.code,
          description: cityDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ cityPageListForAutoCompleteList: filteredSuggestions });
  }
  cityEnterKeyEvent = (e) => {
    let temp_addressData = this.state.addressData;
    let city = e.target.value;

    temp_addressData["city"] = e.target.value;
    let city_List = this.state.cities;
    let cityBean = null;
    city_List.map((city) => {
      if (city.code == e.target.value) {
        cityBean = city;
      }
    });
    if (!isEmpty(cityBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.city = cityBean.code;

      this.setState({
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCityList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCityList: showAutoCompleteList });
  };
  //state
  onStateChange = (e) => {
    let state = e.target.value;
    this.state.showAutoCompleteStateList = true;

    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteStateList;

    if (isEmpty(state)) {
      this.state.showAutoCompleteStateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStateList;
      let temp_addressData = this.state.addressData;
      temp_addressData.state = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteStateList: showAutoCompleteList,
        addressData: temp_addressData,
        statePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && state !== "") {
      this.readstateBySearchString(state);
    }
    if (e.target.name == "state") {
      temp_addressData["state"] = e.target.value;
      let state_List = this.state.states;
      state_List.map((state) => {
        if (state.code == e.target.value) {
          temp_addressData["state"] = state.code;

          this.state.showAutoCompleteStateList = false;
          let showAutoCompleteList = this.state.showAutoCompleteStateList;
          this.setState({ showAutoCompleteStateList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: temp_addressData });
  };
  readstateBySearchString(searchString) {
    let stateData = this.state.states;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletestateLists) =>
        simpleAutoCompletestateLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ statePageListForAutoCompleteList: filteredSuggestions });
  }
  stateEnterKeyEvent = (e) => {
    let temp_addressData = this.state.addressData;
    let state = e.target.value;

    temp_addressData["state"] = e.target.value;
    let state_List = this.state.states;
    let stateBean = null;
    state_List.map((state) => {
      if (state.code == e.target.value) {
        stateBean = state;
      }
    });
    if (!isEmpty(stateBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.state = stateBean.code;

      this.setState({
        addressData: temp_addressData,
        statePageListForAutoCompleteList: new Array(),
      });
    }
  };

  displayAutoCompleteStateList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteStateList: showAutoCompleteList });
  };

  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <ProgressBar
          closeAlertModalCallBack={this.closeAlertProgressBarModalCallBack}
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
            loadingText={this.state.loadingText}
            isLoading={this.state.isLoading}
          />
        )}
        {this.state.isListFormOpen && (
          <div>
            <Row>
              <Col sm="1">
                <FormLabel id="searchBarLabel">InvoicePrintoutType</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  enterKeyEventHandler={this.enterKeyEventHandler}
                  ref={this.listFormCodeRef}
                  type="text"
                  name="code"
                  onChange={this.onChange}
                  value={this.state.invoicePrintTypeData.code}
                  style={{ "text-transform": "uppercase" }}
                  isMandatory={true}
                ></InputTextbox>
              </Col>
              <Col sm="1">
                <Button
                  id="fabric_Add_Button"
                  className="text-center enterFocus"
                  onClick={() => this.clickGoButton()}
                >
                  Go
                </Button>
              </Col>
            </Row>
          </div>
        )}
        {!this.state.isListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
            isShowTitle={true}
          />
        )}
        {this.state.isListFormOpen && (
          <InvoicePrintTypeListForm
            {...this.state}
            clickGoButton={this.clickGoButton}
            editInvoicePrintType={this.editInvoicePrintType}
            enterKeyEventHandler={this.enterKeyEventHandler}
            onChange={this.onChange}
            deleteInvoicePrintType={this.deleteInvoicePrintType}
          />
        )}
        {this.state.isEntryFormOpen && (
          <InvoicePrintTypeEntryForm
            {...this.state}
            onChange={this.onChange}
            uploadImage={this.uploadImage}
            setUrl={this.setUrl}
            showToast={this.showToast}
            setImg={this.setImg}
            deleteImage={this.deleteImage}
            onAddressChange={this.onAddressChange}
            onCountryChange={this.onCountryChange}
            countryCodeEnterKeyEvent={this.countryCodeEnterKeyEvent}
            displayAutoCompleteCountryCodeList={
              this.displayAutoCompleteCountryCodeList
            }
            onCityChange={this.onCityChange}
            cityEnterKeyEvent={this.cityEnterKeyEvent}
            displayAutoCompleteCityList={this.displayAutoCompleteCityList}
            onStateChange={this.onStateChange}
            stateEnterKeyEvent={this.stateEnterKeyEvent}
            displayAutoCompleteStateList={this.displayAutoCompleteStateList}
          />
        )}

        <MessageBoxComponent
          isShowPopup={this.state.isShowWarningMsgPopup}
          warningMesage={this.state.warningMessage}
          title="Warning Message"
          onYesButtonClick={this.onYesButtonClick}
          onNoButtonClick={this.onNoButtonClick}
          closeMessageModelCallBack={this.closeMessageModelCallBack}
        />
      </div>
    );
  }
}

export function PrintoutTypeLogo(props) {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(props.imageUrl);

  useEffect(() => {
    setPreviewUrl(props.imageUrl);
  }, [props.imageUrl]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (file != null) {
      props.setUrl(URL.createObjectURL(file));
      props.setImg(file);
      props.uploadImage(file, "Main");
      props.showToast("Main image uploaded sucessfully", 1);
    }
  };
  const handleChange = (e) => {
    let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;
    if (e.target.files[0].size <= max_size) {
      setFile(e.target.files[0]);
      setPreviewUrl(URL.createObjectURL(e.target.files[0]));
    } else {
      props.showToast("image size is greater", 2);
    }
  };

  const deleteImage = (e) => {
    if (e.detail == 1) {
      setFile(null);
      setPreviewUrl("");

      props.deleteImage();
      props.showToast("Image Deleted sucessfully", 1);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="d-flex justify-content-around ">
          <img
            className="img_div"
            src={previewUrl}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = noImage;
            }}
            width={250}
            height={250}
            mode="fit"
          />
        </div>
        <div className="d-flex justify-content-around ">
          <div>
            <label
              htmlFor="img__logo"
              className="d-flex justify-content-around "
            >
              <div className="img_label">
                Attach Image
                <span className="img_icon">
                  <CameraIcon />
                </span>
              </div>
              <input
                type="file"
                className="img-input"
                id="img__logo"
                accept="image/*"
                onChange={handleChange}
                // disabled={props.isDisabledFields}
              />
            </label>
          </div>
          {!isEmptyString(previewUrl) && (
            <div className="d-flex justify-content-around align-middle">
              <div className="align-middle">
                <Button
                  id="fabric_Add_Button"
                  type="submit"
                  // disabled={props.isDisabledFields}
                >
                  Upload
                </Button>
              </div>
              <div className="align-middle">
                {/* <Button
                  id="fabric_Add_Button"
                  onClick={(e) => deleteImage(e)}
                  disabled={props.isDisabledFields}
                >
                  <DeleteIcon />
                </Button> */}
              </div>
            </div>
          )}
        </div>
      </form>
    </div>
  );
}

function InvoicePrintoutTypeAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <InvoicePrintTypeList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default InvoicePrintoutTypeAttributeModule;
